export const CAREER_FOCUSED_VIEW_ROUTES = [
  /\/compensation\/create\/?$/, // Compensation profile create
  /\/compensation\/[^/]+\/(view|edit)\/?$/, // Compensation profile view/edit
  /\/career-profile\/onboarding\/?$/, // Career Plan create onboarding
  /\/career-profile\/new\/?$/, // Career Plan document create
  /\/career-profile\/plans\/[^/]+\/?$/, // Career Plan document edit
  /\/career-profile\/experience-index\/assessment\/?$/, // Experience Index competency answers
  /\/career-profile\/[^/]+\/?$/, // Career Profile day / Goals / Results focused view
  /\/career-plan\/onboarding\/?$/, // Legacy Career Plan create onboarding
  /\/career-plan\/new\/?$/, // Legacy Career Plan document create
  /\/career-plan\/plans\/[^/]+\/?$/, // Legacy Career Plan document edit
  /\/career-plan\/experience-index\/assessment\/?$/, // Legacy Experience Index competency answers
  /\/career-plan\/[^/]+\/?$/ // Legacy Career Plan day focused view
];

export function isCareerFocusedView(pathname: string) {
  return CAREER_FOCUSED_VIEW_ROUTES.some((route) => route.test(pathname));
}
